import { render, staticRenderFns } from "./dispute-table-invoice-center-stats-breakdown-card.vue?vue&type=template&id=2ceb1b66"
import script from "./dispute-table-invoice-center-stats-breakdown-card.vue?vue&type=script&lang=js"
export * from "./dispute-table-invoice-center-stats-breakdown-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports